var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 372,
    viewBox: "0 0 412 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.508 357.947C85.8979 333.847 1.33671 246.172 0.536372 122.951C0.269637 81.45 10.7587 50.9841 26.6768 30.9042C42.5916 10.8284 63.9506 1.10879 85.5027 1.10879C106.364 1.10879 127.448 10.2276 143.95 27.9497C169.409 55.3054 194.212 72.0913 219.615 81.4417C245.018 90.792 270.99 92.6951 298.767 90.3331C326.378 87.993 356.495 96.6906 378.549 116.654C400.588 136.604 414.61 167.836 409.995 210.652C405.381 253.469 378.361 303.53 333.933 336.267C289.528 368.987 227.727 384.404 153.508 357.947Z",
    stroke: "#00FF66",
    strokeWidth: 0.942197
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.f140c3a7a0876162e93e87b6d1756df6.svg";
export { ForwardRef as ReactComponent };